module.exports = __webpack_public_path__ + "static/media/reddit.7cde1f5b.svg";